import { Spinner } from "react-bootstrap";

interface Props {
  dark?: boolean;
}
const SpinnerForBtn: React.FC<Props> = ({ dark = false }) => {
  return (
    <>
      {dark ? (
        <Spinner
          animation="border"
          variant={dark ? "dark" : "light"}
          size="sm"
        />
      ) : (
        <Spinner animation="grow" size="sm" />
      )}
    </>
  );
};

export default SpinnerForBtn;
